<template>
  <header class="site-header">
    <div class="container nav-wrap">
      <div class="logo" @click="goHome" style="cursor: pointer;">
        <img class="logoimg" src="../assets/logo.png" alt="">
      </div>
      <nav class="nav-menu">
        <a href="#" :class="{ active: activeMenu === 'home' }" @click.prevent="goHome">首页</a>
        <!-- 2. 产品矩阵父级动态绑定 active (当选中任意产品时，父级也高亮) -->
        <div class="nav-item dropdown" :class="{ active: isProductActive }">
          <a href="#products" class="dropdown-toggle">产品矩阵 ▾</a>
          <div class="dropdown-menu">
            <!-- 3. 下拉菜单项动态绑定 active -->
            <a 
              v-for="product in products" 
              :key="product.id" 
              :class="{ active: activeMenu === product.id }"
              @click.prevent="selectProduct(product.id)"
            >
              {{ product.name }}
            </a>
          </div>
        </div>
        
        <!-- 4. 其他菜单项动态绑定 active -->
        <a href="#services" :class="{ active: activeMenu === 'services' }" @click.prevent="scrollTo('services')">服务保障</a>
        <a href="#advantages" :class="{ active: activeMenu === 'advantages' }" @click.prevent="scrollTo('advantages')">合作优势</a>
        <a href="#company" :class="{ active: activeMenu === 'company' }" @click.prevent="scrollTo('company')">关于我们</a>
         <button class="platform-btn" @click="goToPlatform">
          进入智慧平台
        </button>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    currentActive: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 默认首页高亮，如果 prop 有值则使用 prop 的值
      activeMenu: this.currentActive || 'home',
      products: [
        { id: 'video-phone', name: '校园视频公话' },
        { id: 'class-card', name: '电子班牌系统' },
        { id: 'ai-voice', name: 'AI数字人相框系统' },
        { id: 'ai-book', name: 'AI数字人图书检索系统' },
        { id: 'anti-bullying', name: '防霸凌预警系统' },
        { id: 'ai-psychology', name: 'AI数字人心理咨询系统' },
        { id: 'moral-eval', name: '德育评价系统' }
      ]
    }
  },
  computed: {
    // 当当前激活的菜单是某个产品时，让“产品矩阵”父级也保持高亮
    isProductActive() {
      return this.products.some(p => p.id === this.activeMenu);
    }
  },
  watch: {
    // 监听父组件传来的 currentActive，实现外部控制高亮
    currentActive(newVal) {
      if (newVal) {
        this.activeMenu = newVal;
      }
    }
  },
  methods: {
    selectProduct(productId) {
      this.activeMenu = productId; // 更新当前高亮状态
      // console.log('导航栏选择了产品:', productId);
      this.$emit('select-product', productId);
    },
    goHome() {
      this.activeMenu = 'home'; // 更新当前高亮状态
      this.$emit('go-home');
    },
    // AppHeader.vue 的 methods 中
    scrollTo(id) {
      this.activeMenu = id; 
      // 只负责通知父组件：用户想跳转到哪个区块
      this.$emit('navigate-to-section', id);
    },
     goToPlatform() {
      // 这里替换为您实际的跳转链接
      // 如果是外部链接：
      window.open('https://www.zg10099.cn/smartCampus/', '_blank');
      
      // 如果是内部路由跳转，可以使用：
      // this.$router.push('/platform');
      
      console.log('跳转到智慧平台');
    }
  }
}
</script>

<style scoped>
.site-header {
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo {
  color: #02a8ea; /* 统一主题色 */
}
.logoimg {
  width: 120px;
  height: 38px;
}

.nav-menu {
  display: flex;
  font-weight: bold;
  gap: 30px;
  align-items: center;
}

.nav-menu a {
  font-size: 16px;
  color: #333;
  transition: color 0.3s;
  text-decoration: none;
}

/* 5. 将高亮颜色统一修改为 #02a8ea */
.nav-menu a:hover,
.nav-menu a.active {
  color: #02a8ea;
  font-weight: bold;
}

/* 新增：下拉菜单样式 */
.nav-item { 
  position: relative; 
  padding-bottom: 10px; 
  margin-bottom: -10px; 
}

.dropdown-toggle { 
  cursor: pointer; 
  display: block; 
}

/* 当父级 dropdown 处于 active 状态时，toggle 文字也高亮 */
.nav-item.dropdown.active .dropdown-toggle {
  color: #02a8ea;
}

.dropdown-menu {
  display: none; 
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  border-radius: 8px;
  padding: 10px 0;
  min-width: 180px;
  z-index: 101;
  margin-top: 0; 
}

.nav-item:hover .dropdown-menu {
  display: block;
}

.dropdown-menu a {
  display: block;
  padding: 10px 20px;
  color: #333 !important; 
  font-weight: normal !important;
  text-align: center;
  white-space: nowrap;
  transition: all 0.3s;
}

.dropdown-menu a:hover {
  background: #f0f7ff;
  color: #02a8ea !important;
}

/* 6. 下拉菜单中被选中的项，增加背景色和加粗，高亮更明显 */
.dropdown-menu a.active {
  color: #02a8ea !important;
  font-weight: bold !important;
  background: #e6f4ff;
}
/* --- 新增按钮样式 --- */
.platform-btn {
  background-color: #02a8ea; /* 主题蓝色 */
  color: #fff;
  border: none;
  padding: 8px 16px;
  /* margin-bottom: 5px; */

  border-radius: 20px; /* 圆角 */
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  /* box-shadow: 0 2px 5px rgba(2, 168, 234, 0.3); */
  white-space: nowrap;
}

.platform-btn:hover {
  background-color: #028ec4; /* 鼠标悬停变深 */
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(2, 168, 234, 0.4);
}

.platform-btn:active {
  transform: translateY(1px);
}
</style>